import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    color: theme.palette.textField.main,
  },
  title: {
    fontFamily: 'Poppins',
    fontSize: '14px',
    letterSpacing: '0.25px',
    width: '110%',
  },
  recommendations: {
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontWeight: 400,
    marginBottom: theme.spacing(2),
  },
  verticalDivider: {
    width: theme.spacing(0.125),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: theme.spacing(0.5),
    background: theme.palette.dividerV2.main,
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
  },
}))
